module.exports = __webpack_public_path__ + "img/h-logo.27697602.png";